import styled from 'styled-components';

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.black3};
`;
